import {
  Component,
  Input,
  OnChanges,
} from '@angular/core';

@Component({
  selector: 'canvas-wizard-progress',
  templateUrl: './wizard-progress.component.html',
  styleUrl: './wizard-progress.component.scss',
  standalone: false
})
export class WizardProgressComponent implements OnChanges {
  progressPercentage!: number;

  @Input() title = '';
  @Input() currentPage!: number;
  @Input() totalPages!: number;
  @Input() progressColor!: string;

  ngOnChanges() {
    this.progressPercentage = (this.currentPage / this.totalPages) * 100;
  }
}
